import React from 'react';
import styled from '@emotion/styled';

export const IconPlans = () => {
  return (
    <StyledIconPlansSpan className="icon-svg IconPlans">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs />
        <g className="a">
          <rect className="b" width="24" height="24" />
          <g transform="translate(4 4)">
            <path className="c" d="M0,15.522H15.53V0H0Z" transform="translate(0 2.01)" />
            <g transform="translate(5 7.532)">
              <path className="c" d="M0,1.414,1.414,2.828,4.242,0" transform="translate(0.644 0.824)" />
            </g>
            <path className="c" d="M0,1.218H4.381V0H0Z" transform="translate(5.575 0)" />
          </g>
        </g>
      </svg>
    </StyledIconPlansSpan>
  );
};

const StyledIconPlansSpan = styled.span`
  & .a {
    opacity: 0.7;
  }

  & .b {
    fill: none;
  }

  & .c {
    stroke: #fff;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    stroke-width: 2px;
  }

  display: inline-block;
  vertical-align: sub;
`;
